<template>

<div id="app">

  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>

      <!--<div class="footer">
        Усі права застережено<br />© <a target="_blank" href="http://ababahalamaha.com.ua">«А-БА-БА-ГА-ЛА-МА-ГА»</a>, 2020
      </div>  -->
  


</div>

  

</template>


<script>
//import AppHeader from './Header'
//import Footerr from './Footer'




export default {

   data() {
    return {


  
    }    
  },



  watch: {
    '$route' (to, from) {


    }
  },

   mounted () {


    },

  created: function() {
  

   }, 

   methods: {



  }
  
  }

</script>